import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { Contractor, Prospective } from '@huge-monorepo/hip/domain';
import { Job } from '@huge-monorepo/hip/domain';
import { Department } from '@huge-monorepo/hip/domain';
import { MainDocumentClass } from '@huge-monorepo/hip/domain';
import { SubDocumentClass } from '@huge-monorepo/hip/domain';
import { Supplier } from '@huge-monorepo/hip/domain';
import { Customer } from '@huge-monorepo/hip/domain';
import { GenericService } from '@huge-monorepo/hip/services';
import { Endpoints } from '@huge-monorepo/hip/services';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { DocumentExtension } from '@huge-monorepo/hip/domain';
import { ToolsService } from '@huge-monorepo/hip/services';

@Component({
  selector: 'tools-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss'],
})
export class UploadDocumentComponent implements OnInit {
  @ViewChild('customerInput', { static: false }) public customerInput: AutocompleteComponent;
  @ViewChild('supplierInput', { static: false }) public supplierInput: AutocompleteComponent;
  @ViewChild('contractorInput', { static: false }) public contractorInput: AutocompleteComponent;
  @ViewChild('prospectiveInput', { static: false }) public prospectiveInput: AutocompleteComponent;
  @ViewChild('fileInput', { static: false }) public fileInput: HTMLInputElement;

  @Input() data: {
    entryPage: 'default' | 'job' | 'contractor';
    lengthContractors?: number;
    customer?: Customer;
    contractor?: Contractor;
    supplier?: Supplier;
    prospective?: Prospective;
    job?: Job;
    selectedDepartment?: Department;
    selectedDepartmentID?: number;
    closeAfterUpload?: boolean;
  } = null;
  entryPage: 'default' | 'job' | 'contractor';
  documents: FileList;
  documentsArray: File[] = [];
  isRelatedToJob: UntypedFormControl;
  showPreview: boolean = false;
  previewURL: string = '';
  customerDisabled: boolean = false;
  supplierDisabled: boolean = false;
  prospectiveDisabled: boolean = false;
  contractorDisabled: boolean = false;
  selectedCustomer: Customer = null;
  selectedSupplier: Supplier = null;
  selectedProspective: Prospective = null;
  selectedContractor: Contractor = null;
  isForContractorTab: UntypedFormControl = null;
  selectedDepartment: Department = null;
  selectedDocumentType: MainDocumentClass = null;
  selectedSubDocumentType: SubDocumentClass = null;
  departments: Department[] = [];
  acceptableCondition: boolean = false;
  informationCorrect: boolean = false;
  documentDetailsForm: UntypedFormGroup = new UntypedFormGroup({
    documentDescription: new UntypedFormControl(null, Validators.required),
    jobNumbers: this.formBuilder.array([]),
  });
  jobDisabled: boolean = false;
  jobs: Job[] = [];
  showJobText: boolean = false;
  showJobDropdown: boolean = false;
  loading: boolean = true;
  loadingDropDowns: boolean = true;
  previewLoaded: boolean = false;

  working: boolean = false;
  extensions: DocumentExtension[];
  allowedExtensionText: string = 'None Specified';
  invalidCharacters = this.tools.invalidFilepathCharacters;

  selectedOption: 'customer' | 'supplier' | 'prospective' | 'contractor' = 'customer';

  constructor(
    public dialogRef: MatDialogRef<UploadDocumentComponent>,
    @Inject(MAT_DIALOG_DATA)
    public entryData: {
      entryPage: 'default' | 'job' | 'contractor';
      lengthContractors?: number;
      customer?: Customer;
      contractor?: Contractor;
      supplier?: Supplier;
      prospective?: Prospective;
      job?: Job;
      selectedDepartment?: Department;
    },
    private db: GenericService,
    private endpoints: Endpoints,
    private tools: ToolsService,
    private formBuilder: FormBuilder,
  ) { }

  get jobNumbersArray() {
    return this.documentDetailsForm.get('jobNumbers') as FormArray<UntypedFormControl>;
  }

  ngOnInit(): void {
    if (this.data == null) {
      this.data = this.entryData;
    }
    this.entryPage = this.data.entryPage;
    this.getDepartments();
    this.getDocumentExtensions();
    if (this.entryPage == 'job' || this.entryPage == 'contractor') {
      this.getJobs();
    }
    this.setup();
  }

  setup(after?: boolean) {
    switch (this.entryPage) {
      case 'default':
        this.showJobDropdown = false;
        this.showJobText = true;
        this.customerDisabled = (this.data.supplier != null || this.data.prospective != null) ? true : false;
        this.supplierDisabled = (this.data.customer != null || this.data.prospective != null) ? true : false;
        this.prospectiveDisabled = (this.data.customer != null || this.data.supplier != null) ? true : false;
        this.selectedCustomer = this.data.customer;
        this.selectedSupplier = this.data.supplier;
        this.selectedProspective = this.data.prospective;
        this.selectedContractor = this.data.contractor;
        if (this.selectedCustomer){
          this.selectedOption = 'customer';
        } else if (this.selectedSupplier) {
          this.selectedOption = 'supplier';
        } else if (this.selectedProspective) {
          this.selectedOption = 'prospective'
        } else if (this.selectedContractor || (this.data.lengthContractors && this.data.lengthContractors)) {
          this.selectedOption = 'contractor'
        }

        break;

      case 'job':
        this.isForContractorTab = new UntypedFormControl(false);
        this.customerDisabled = true;
        this.supplierDisabled = true;
        this.prospectiveDisabled = true;
        this.contractorDisabled = true;
        this.jobDisabled = true;
        this.selectedCustomer = this.data.customer;
        this.isForContractorTab.valueChanges.subscribe((value) => {
          this.loadingDropDowns = true;
          if (value) {
            this.selectedContractor = null;
            this.selectedContractor = this.data.contractor;
            this.selectedOption = 'contractor';
            this.selectedCustomer = null;
            this.isRelatedToJob = new UntypedFormControl(true);
            this.isRelatedToJob.valueChanges.subscribe((value) => {
              if (value) {
                const newForm = new UntypedFormControl(this.data.job?.JobNumber, Validators.required);
                this.jobNumbersArray.push(newForm);
                // this.documentDetailsForm.addControl('jobNumber', new UntypedFormControl(this.data.job?.JobNumber, Validators.required));
                newForm.disable();
                // this.documentDetailsForm.controls['jobNumber'].disable();
              } else {
                this.jobNumbersArray.clear();
                // this.documentDetailsForm.removeControl('jobNumber');
              }
            });
          } else {
            this.selectedCustomer = null;
            this.selectedCustomer = this.data.customer;
            this.selectedOption = 'customer';
            this.selectedContractor = null;
            this.isRelatedToJob = null;
          }
          setTimeout(() => {
            this.loadingDropDowns = false;
          });
        });
        this.showJobText = false;
        this.showJobDropdown = true;
        this.isRelatedToJob = null;
        break;

      case 'contractor':
        this.selectedContractor = this.data.contractor;
        this.selectedOption = 'contractor';
        this.customerDisabled = true;
        this.supplierDisabled = true;
        this.contractorDisabled = true;
        this.prospectiveDisabled = true;
        this.showJobDropdown = true;
        this.showJobText = false;
        break;

      default:
        break;
    }
    if (after) {
      this.documentDetailsForm = new UntypedFormGroup({
        documentDescription: new UntypedFormControl(null, Validators.required),
        jobNumbers: this.formBuilder.array([]),
      });
      this.documents = null;
      this.documentsArray = [];
      this.selectedDepartment = this.data?.selectedDepartment;
      this.acceptableCondition = false;
      this.informationCorrect = false;
      this.selectedDocumentType = null;
      this.selectedSubDocumentType = null;
      this.previewURL = null;
      this.showPreview = false;
    }
    this.loading = false;
    this.loadingDropDowns = false;
  }

  getDepartments() {
    this.db.GET(this.endpoints.GET_DEPARTMENTS(0, null, null, null, { orderBy: 'Name' })).subscribe((results) => {
      this.departments = results['body'] as Department[];
      if (this.data.selectedDepartment != null) {
        this.selectedDepartment = this.data.selectedDepartment;
      }
      if (this.data.selectedDepartmentID != null) {
        this.selectedDepartment = this.departments.find((dep) => dep.ID == this.data.selectedDepartmentID);
      }
      if (this.departments != null) return;
      this.db.createToast('Invalid Departments', 'You are not assigned to any departments', 'error');
    });
  }

  getDocumentExtensions() {
    this.db.GET(this.endpoints.GET_DOCUMENT_EXTENSIONS(null, null, null, null, '')).subscribe((results) => {
      this.extensions = results['body'] as DocumentExtension[];
      this.allowedExtensionText = '';
      this.extensions.forEach((element) => {
        this.allowedExtensionText += element.Name + ' ';
      });
    });
  }

  getJobs() {
    this.db.GET(this.endpoints.GET_JOBS(null, null, null, 'AccountNumber', null, true, false, null, false, "", null, null)).subscribe((data) => {
      this.jobs = data['body'] as Job[];
    });
  }

  handleDroppedFiles(files) {
    let input = document.getElementById('fileInput') as HTMLInputElement;
    if (input != null) {
      this.onFileInput(input, files);
    }
  }

  onFileInput(input, files: FileList) {
    if (this.working) {
      this.db.createToast('Busy Uploading', 'You cannot change the file list whilst uploading. Please wait for the current process to finish', 'error');
      return;
    }
    let isPDF = false;
    let found = false;

    if (files != null) {
      this.extensions.forEach((element) => {
        if (!found && element.Name.toLowerCase() == '.' + (files[0]['name'].split('.').pop() as String).toLowerCase()) {
          found = true;
          if (element.Name.toLowerCase() == '.pdf') {
            isPDF = true;
          }
        }
      });
    }

    if (!found) {
      this.db.createToast('Invalid Files', 'One or more files are not allowed. Please remove these and try again.', 'error');
      if (input != null) {
        input.value = '';
      }
      return;
    }

    this.documents = files;
    Array.prototype.forEach.call(this.documents, (file) => {
      this.documentsArray.push(file);
    });
    if (isPDF) {
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.showPreview = true;
          this.previewURL = e.target['result'] as string;
        };
        reader.readAsDataURL(files[0]);
      }
    }
  }

  viewExtensions() {
    this.db.createToast('Allowed Extensions', this.allowedExtensionText, 'info', 8);
  }

  deleteFile(index: number, f: any[]) {
    let list = new DataTransfer();
    for (let i = 0; i < f.length; i++) {
      if (i != index) {
        list.items.add(f[i]);
      }
    }

    this.documentsArray = [];
    this.documents = list.files;

    Array.prototype.forEach.call(this.documents, (file) => {
      this.documentsArray.push(file);
    });

    if (list.files.length == 0) {
      this.previewURL = null;
      this.showPreview = false;
      setTimeout(() => {
        if (this.fileInput != null) {
          this.fileInput.files = list.files;
        }
      }, 100);
    } else {
      if (this.fileInput != null) {
        this.fileInput.files = list.files;
      }
    }
  }

  customerSelected(cust: Customer) {
    this.selectedCustomer = cust;
    this.selectedSupplier = null;
    this.selectedContractor = null;
    this.selectedProspective = null;

    if (this.selectedCustomer == null && this.supplierInput) {
      this.supplierInput.enable();
    } else if (this.supplierInput) {
      this.supplierInput.disable();
    }

    if (this.selectedCustomer == null && this.contractorInput) {
      this.contractorInput.enable();
    } else if (this.contractorInput) {
      this.contractorInput.disable();
    }

    if (this.selectedCustomer == null && this.prospectiveInput) {
      this.prospectiveInput.enable();
    } else if (this.prospectiveInput) {
      this.prospectiveInput.disable();
    }

  }

  supplierSelected(sup: Supplier) {
    this.selectedSupplier = sup;
    this.selectedCustomer = null;
    this.selectedContractor = null;
    this.selectedProspective = null;
    if (this.selectedSupplier == null && this.customerInput) {
      this.customerInput.enable();
    } else if (this.customerInput) {
      this.customerInput.disable();
    }

    if (this.selectedSupplier == null && this.contractorInput) {
      this.contractorInput.enable();
    } else if (this.contractorInput) {
      this.contractorInput.disable();
    }

    if (this.selectedSupplier == null && this.prospectiveInput) {
      this.prospectiveInput.enable();
    } else if (this.prospectiveInput) {
      this.prospectiveInput.disable();
    }
  }

  prospectiveSelected(pro: Prospective) {
    this.selectedProspective = pro;
    this.selectedCustomer = null;
    this.selectedContractor = null;
    this.selectedSupplier = null;
    if (this.selectedProspective == null && this.customerInput) {
      this.customerInput.enable();
    } else if (this.customerInput) {
      this.customerInput.disable();
    }

    if (this.selectedProspective == null && this.contractorInput) {
      this.contractorInput.enable();
    } else if (this.contractorInput) {
      this.contractorInput.disable();
    }

    if (this.selectedProspective == null && this.supplierInput) {
      this.supplierInput.enable();
    } else if (this.contractorInput) {
      this.supplierInput.disable();
    }
  }

  contractorSelected(contr: Contractor) {
    this.selectedContractor = contr;
    this.selectedSupplier = null;
    this.selectedCustomer = null;
    this.selectedProspective = null;

    if (this.selectedContractor == null && this.customerInput) {
      this.customerInput.enable();
    } else if (this.customerInput) {
      this.customerInput.disable();
    }

    if (this.selectedContractor == null && this.supplierInput) {
      this.supplierInput.enable();
    } else if (this.supplierInput) {
      this.supplierInput.disable();
    }

    if (this.selectedContractor == null && this.prospectiveInput) {
      this.prospectiveInput.enable();
    } else if (this.prospectiveInput) {
      this.prospectiveInput.disable();
    }
  }

  departmentSelected(event: Department) {
    this.selectedDepartment = null;
    setTimeout(() => {
      this.selectedDepartment = event;
      this.selectedDocumentType = null;
      this.selectedSubDocumentType = null;
    });
  }

  documentTypeSelected(event: MainDocumentClass) {
    this.selectedDocumentType = null;
    setTimeout(() => {
      this.selectedDocumentType = event;
      this.selectedSubDocumentType = null;
    });
  }

  subDocumentTypeSelected(event: SubDocumentClass) {
    this.selectedSubDocumentType = event;
    switch (this.entryPage) {
      case 'default':
        // this.documentDetailsForm.addControl('jobNumber', new UntypedFormControl(null));
        const newForm = new UntypedFormControl(null, Validators.pattern('([a-zA-Z0-9])*'));
        this.jobNumbersArray.push(newForm);
        this.documentDetailsForm.addControl('inventoryNumber', new UntypedFormControl(null));

        break;

      case 'contractor':
        this.isRelatedToJob = new UntypedFormControl(false);

        this.isRelatedToJob.valueChanges.subscribe((value) => {
          if (value) {
            // this.documentDetailsForm.addControl('jobNumber', new UntypedFormControl(null, Validators.required));
            const newForm = new UntypedFormControl(null, Validators.required);
            this.jobNumbersArray.push(newForm);

          } else {
            // this.documentDetailsForm.removeControl('jobNumber');
            this.jobNumbersArray.clear();
          }
        });
        break;

      case 'job':
        this.isRelatedToJob = new UntypedFormControl(true);
        if (this.isForContractorTab.value) {
          // this.documentDetailsForm.addControl('jobNumber', new UntypedFormControl(this.data.job?.JobNumber));
          const newForm = new UntypedFormControl(this.data.job?.JobNumber);
          this.jobNumbersArray.push(newForm);
          this.isRelatedToJob.valueChanges.subscribe((value) => {
            if (value) {
              const newForm = new UntypedFormControl(this.data.job?.JobNumber);
              newForm.setValue(this.data.job?.JobNumber);
              newForm.disable();
              this.jobNumbersArray.push(newForm);


              // this.documentDetailsForm.addControl('jobNumber', new UntypedFormControl(this.data.job?.JobNumber));
              // this.documentDetailsForm.get('jobNumber').setValue(this.data.job?.JobNumber);
              // this.documentDetailsForm.controls['jobNumber'].disable();
            } else {
              this.jobNumbersArray.clear();
              // this.documentDetailsForm.removeControl('jobNumber');
            }
          });
        } else {
          const newForm = new UntypedFormControl(this.data.job?.JobNumber);
          newForm.setValue(this.data.job?.JobNumber);
          this.jobNumbersArray.push(newForm);

          // this.documentDetailsForm.addControl('jobNumber', new UntypedFormControl(this.data.job?.JobNumber));
          // this.documentDetailsForm.get('jobNumber').setValue(this.data.job?.JobNumber);
        }
        // this.documentDetailsForm.controls['jobNumber'].disable();
        this.jobNumbersArray.controls.forEach(element => {
          element.disable();
        });
        break;

      default:
        break;
    }
  }

  submitDocument() {
    this.loading = true;
    //CASE 1 Contractor page and is related to job
    if (this.entryPage == 'contractor' && this.isRelatedToJob && this.isRelatedToJob.value == true) {
      //TODO ask how to actually upload the files?
      this.db
        .UploadFiles(this.endpoints.UPLOAD_DOCUMENT_FOR_CONTRACTOR(), this.documents as unknown as FileList, {
          ContractorID: this.selectedContractor.ID,
          DocumentSubClassID: this.selectedSubDocumentType.ID,
          DepartmentID: this.selectedDepartment.ID,
          TypeFieldValues: this.selectedSubDocumentType.DocumentFields.map((v) => {
            return {
              Label: v['value'],
              Value: v['v'],
            };
          }),
          InvNum: this.documentDetailsForm.value.inventoryNumber,
          JobNumbers: this.jobNumbersArray.value.filter(elm => { return (elm != null && elm !== ""); }),
          Description: this.documentDetailsForm.value.documentDescription,
          IsActive: true,
        })
        .pipe(finalize(() => this.setup(true)))
        .subscribe((val) => {
          this.db.createToast('File Uploaded', 'The document has been uploaded successfully');
          if (this.data.closeAfterUpload) this.dialogRef.close(true);
        });
    }

    //CASE 2 Contractor page and is not related to job
    if (this.entryPage == 'contractor' && this.isRelatedToJob && this.isRelatedToJob.value == false) {
      this.db
        .UploadFiles(this.endpoints.UPLOAD_DOCUMENT_FOR_CONTRACTOR(), this.documents as unknown as FileList, {
          ContractorID: this.selectedContractor.ID,
          DocumentSubClassID: this.selectedSubDocumentType.ID,
          DepartmentID: this.selectedDepartment.ID,
          TypeFieldValues: this.selectedSubDocumentType.DocumentFields.map((v) => {
            return {
              Label: v['value'],
              Value: v['v'],
            };
          }),
          InvNum: this.documentDetailsForm.value.inventoryNumber,
          JobNumbers: this.jobNumbersArray.value.filter(elm => { return (elm != null && elm !== ""); }),
          Description: this.documentDetailsForm.value.documentDescription,
          IsActive: true,
        })
        .pipe(finalize(() => this.setup(true)))
        .subscribe((val) => {
          this.db.createToast('File Uploaded', 'The document has been uploaded successfully');
          if (this.data.closeAfterUpload) this.dialogRef.close(true);
        });
    }

    //CASE 3 Job page and is contractor and is related to job
    if (this.entryPage == 'job' && this.isForContractorTab && this.isForContractorTab.value == true) {
      this.db
        .UploadFiles(this.endpoints.UPLOAD_DOCUMENT_FOR_JOB(this.documentDetailsForm.value.jobNumber?.ID ?? this.data.job.ID), this.documents as unknown as FileList, {
          ContractorID: this.selectedContractor.ID,
          DocumentSubClassID: this.selectedSubDocumentType.ID,
          DepartmentID: this.selectedDepartment.ID,
          TypeFieldValues: this.selectedSubDocumentType.DocumentFields.map((v) => {
            return {
              Label: v['value'],
              Value: v['v'],
            };
          }),
          InvNum: this.documentDetailsForm.value.inventoryNumber,
          JobNumbers: this.jobNumbersArray.value.filter(elm => { return (elm != null && elm !== ""); }).length > 0 ? this.jobNumbersArray.value.filter(elm => { return (elm != null && elm !== ""); }) : this.data.job.JobNumber,
          Description: this.documentDetailsForm.value.documentDescription,
          IsActive: true,
        })
        .pipe(finalize(() => this.setup(true)))
        .subscribe((val) => {
          this.db.createToast('File Uploaded', 'The document has been uploaded successfully');
          if (this.data.closeAfterUpload) this.dialogRef.close(true);
        });
    }

    //CASE 4 Job page and is contractor and is not related to job
    if (this.entryPage == 'job' && this.isForContractorTab && this.isForContractorTab.value == true && this.isRelatedToJob && this.isRelatedToJob.value == false) {
      this.db
        .UploadFiles(this.endpoints.UPLOAD_DOCUMENT_FOR_JOB(), this.documents as unknown as FileList, {
          ContractorID: this.selectedContractor.ID,
          DocumentSubClassID: this.selectedSubDocumentType.ID,
          DepartmentID: this.selectedDepartment.ID,
          TypeFieldValues: this.selectedSubDocumentType.DocumentFields.map((v) => {
            return {
              Label: v['value'],
              Value: v['v'],
            };
          }),
          InvNum: this.documentDetailsForm.value.inventoryNumber,
          JobNumbers: this.jobNumbersArray.value.filter(elm => { return (elm != null && elm !== ""); }),
          Description: this.documentDetailsForm.value.documentDescription,
          IsActive: true,
        })
        .pipe(finalize(() => this.setup(true)))
        .subscribe((val) => {
          this.db.createToast('File Uploaded', 'The document has been uploaded successfully');
          if (this.data.closeAfterUpload) this.dialogRef.close(true);
        });
    }

    //CASE 5 job page and is not contractor
    if (this.entryPage == 'job' && this.isForContractorTab && this.isForContractorTab.value == false) {
      this.db
        .UploadFiles(this.endpoints.UPLOAD_DOCUMENT_FOR_JOB(this.data.job.ID ?? this.documentDetailsForm.value.jobNumber.ID), this.documents as unknown as FileList, {
          CustomerID: this.selectedCustomer.id,
          DocumentSubClassID: this.selectedSubDocumentType.ID,
          DepartmentID: this.selectedDepartment.ID,
          TypeFieldValues: this.selectedSubDocumentType.DocumentFields.map((v) => {
            return {
              Label: v['value'],
              Value: v['v'],
            };
          }),
          InvNum: this.documentDetailsForm.value.inventoryNumber,
          JobNumbers: this.jobNumbersArray.value.filter(elm => { return (elm != null && elm !== ""); }).length > 0 ? this.jobNumbersArray.value.filter(elm => { return (elm != null && elm !== ""); }) : this.data.job.JobNumber,
          Description: this.documentDetailsForm.value.documentDescription,
          IsActive: true,
        })
        .pipe(finalize(() => this.setup(true)))
        .subscribe((val) => {
          this.db.createToast('File Uploaded', 'The document has been uploaded successfully');
          if (this.data.closeAfterUpload) this.dialogRef.close(true);
        });
    }

    //CASE 6 default
    if (this.entryPage == 'default') {
      this.db
        .UploadFiles(this.endpoints.UPLOAD_DOCUMENTS(null, null), this.documents as unknown as FileList, {
          CustomerID: this.selectedCustomer != null ? this.selectedCustomer.id : null,
          SupplierID: this.selectedSupplier != null ? this.selectedSupplier.ID : null,
          ProspectiveID: this.selectedProspective != null ? this.selectedProspective.ID : null,
          ContractorID: this.selectedContractor != null ? this.selectedContractor.ID : null,
          DocumentExtensionID: null,
          DocumentSubClassID: this.selectedSubDocumentType.ID,
          DepartmentID: this.selectedDepartment.ID,
          FieldValues: [],
          TypeFieldValues: this.selectedSubDocumentType.DocumentFields.map((v) => {
            return {
              Label: v['value'],
              Value: v['v'],
            };
          }),
          InvNum: this.documentDetailsForm.value.inventoryNumber,
          JobNumbers: this.jobNumbersArray.value.filter(elm => { return (elm != null && elm !== ""); }),
          Description: this.documentDetailsForm.value.documentDescription,
          IsActive: true,
        })
        .pipe(finalize(() => this.setup(true)))
        .subscribe((results) => {
          if (this.documents.length > 1) {
            this.db.createToast('Files Uploaded', 'The documents have been uploaded and merged successfully');
          } else {
            this.db.createToast('File Uploaded', 'The document has been uploaded successfully');
          }
          if (this.data.closeAfterUpload) this.dialogRef.close(true);
        });
    }

    // 1 /api/jobs/document/
    // 2 /api/jobs/document/jobId=19
    // 3 /api/contractors/document/
    // 4 /api/contractors/document/jobId=19
    // 5 /api/jobs/?contractorId=19
    // 6 /api/jobs/?customerId=19
    if (this.entryData['entrypage'] != undefined) {
      this.dialogRef.close();
    }
  }

  jobSelected(job): void {
    if (this.jobNumbersArray.controls.length === 0) {
      const newForm = new UntypedFormControl(job.JobNumber);
      this.jobNumbersArray.push(newForm);
    } else {
      this.jobNumbersArray.controls[0].setValue(job.JobNumber);
    }
    // this.documentDetailsForm.get('jobNumber').setValue(job.JobNumber);
  }

  createNewJobNumber() {
    const newForm = new UntypedFormControl(null, Validators.pattern('([a-zA-Z0-9])*'));
    this.jobNumbersArray.push(newForm);
  }

  removeJobNumber(index: number) {
    this.jobNumbersArray.removeAt(index);
  }
}
